import qs from 'qs';
const strapiConstants = {
  queries: {
    blogHome: qs.stringify(
      {
        sort: 'createdAt:desc',
        populate: {
          seo: true,
          thumbnailImage: true,
          contributor: {
            populate: 'image', // Populiert die Relation 'image' innerhalb von 'contributor'
          },
          localizations: true,
        },
        pagination: {
          start: 0,
          limit: 6,
        },
      },
      {
        encodeValuesOnly: true, // prettify URL
      }
    ),
    allBlogPosts: qs.stringify(
      {
        sort: 'createdAt:desc',
        populate: {
          seo: true,
          thumbnailImage: true,
          contributor: {
            populate: 'image', // Populiert die Relation 'image' innerhalb von 'contributor'
          },
          localizations: true,
        },
        pagination: {
          start: 0,
          limit: 100,
          pageSize: 300,
        },
      },
      {
        encodeValuesOnly: true, // prettify URL
      }
    ),
    allBlogs: qs.stringify(
      {
        sort: 'createdAt:desc',
        populate: {
          seo: true,
          thumbnailImage: true,
          contributor: {
            populate: 'image', // Populiert die Relation 'image' innerhalb von 'contributor'
          },
          localizations: true,
        },
        pagination: {
          pageSize: 300,
        },
      },
      {
        encodeValuesOnly: true, // prettify URL
      }
    ),
    Articles_3: qs.stringify(
      {
        sort: 'createdAt:desc', // Sortiere nach Erstellungsdatum (absteigend)
        populate: {
          seo: true,
          thumbnailImage: true,
          contributor: {
            populate: 'image', // Populiert die Relation 'image' innerhalb von 'contributor'
          },
        },
        pagination: {
          start: 0, // Starte beim ersten Eintrag
          limit: 4, // Begrenze auf 3 Einträge
        },
      },
      {
        encodeValuesOnly: true, // prettify URL
      }
    ),
    singleLandingPageBySlug: (slug: string) => {
      return qs.stringify(
        {
          sort: 'createdAt:desc',
          populate: '*',
          filters: {
            slug: {
              $eqi: slug.trim().toLowerCase(),
            },
          },
        },
        {
          encodeValuesOnly: true, // prettify URL
        }
      );
    },
    allBlogsWithSearch: (search: string) =>
      qs.stringify(
        {
          filters: {
            $or: [
              { title: { $containsi: search } },
              { description: { $containsi: search } },
              { content: { $containsi: search } },
              { slug: { $containsi: search } },
            ],
          },
          sort: ['createdAt:desc'],
          populate: '*',
          pagination: {
            start: 0,
            limit: 10,
          },
        },
        {
          encodeValuesOnly: true,
        }
      ),
    blogHomeLocale: (locale?: string) => {
      return qs.stringify(
        {
          sort: 'createdAt:desc',
          populate: '*',
          pagination: {
            start: 0,
            limit: 4,
          },
          locale: locale || 'en',
        },
        {
          encodeValuesOnly: true, // prettify URL
        }
      );
    },
    singleBlogById: (bId: string, locale: string) =>
      qs.stringify(
        {
          sort: 'createdAt:desc',
          populate: {
            seo: true,
            thumbnailImage: true,
            contributor: {
              populate: 'image', // Populiert die Relation 'image' innerhalb von 'contributor'
            },
            localizations: true,
          },
          filters: {
            id: {
              $eq: bId,
            },
          },
          locale: locale || 'en',
        },
        {
          encodeValuesOnly: true, // prettify URL
        }
      ),
    singleBlogByDocumentId: (documentId: string, locale: string) =>
      qs.stringify(
        {
          sort: 'createdAt:desc',
          populate: {
            seo: true,
            thumbnailImage: true,
            contributor: {
              populate: 'image', // Populiert die Relation 'image' innerhalb von 'contributor'
            },
            localizations: true,
          },
          filters: {
            documentId: documentId,
          },
          locale: locale || 'en',
        },
        {
          encodeValuesOnly: true, // prettify URL
        }
      ),
    singleBlogBySlug: (slug: string, locale: string) =>
      qs.stringify({
        sort: 'createdAt:desc',
        populate: {
          seo: true,
          thumbnailImage: true,
          contributor: {
            populate: 'image', // Populiert die Relation 'image' innerhalb von 'contributor'
          },
          localizations: true,
        },
        filters: {
          slug: {
            $eq: slug,
          },
        },
        locale: locale || 'en',
      }),
    allBlogsLocale: (locale?: string) => {
      return qs.stringify(
        {
          sort: 'createdAt:desc',
          populate: {
            seo: true,
            thumbnailImage: true,
            contributor: {
              populate: 'image', // Populiert die Relation 'image' innerhalb von 'contributor'
            },
            localizations: true,
          },
          pagination: {
            start: 0,
            limit: 100,
          },
          locale: locale || 'en',
        },
        {
          encodeValuesOnly: true, // prettify URL
        }
      );
    },
    collection: qs.stringify(
      {
        sort: 'createdAt:desc',
        populate: ['skus', 'contributor', 'contributor.image', 'image', 'localizations'],
      },
      {
        encodeValuesOnly: true, // prettify URL
      }
    ),
    collectionLocale: (locale?: string) => {
      return qs.stringify(
        {
          sort: 'createdAt:desc',
          populate: ['skus', 'contributor', 'contributor.image', 'image', 'localizations'],
          locale: locale || 'en',
        },
        {
          encodeValuesOnly: true, // prettify URL
        }
      );
    },
    blogContributors: (locale: string) =>
      qs.stringify({
        populate: [
          'blogs',
          'image',
          'blogs.thumbnailImage',
          'blogs.contributor',
          'blogs.contributor.image',
          'blogs.seo',
        ],
        locale: locale || 'en',
      }),
    blogContributor: (locale: string, slug: string) =>
      qs.stringify({
        populate: [
          'blogs',
          'image',
          'blogs.thumbnailImage',
          'blogs.contributor',
          'blogs.contributor.image',
          'blogs.seo',
        ],
        locale: locale || 'en',
        filters: {
          slug: {
            $eq: slug,
          },
        },
      }),
  },
};

export default strapiConstants;
